// extracted by mini-css-extract-plugin
module.exports = {"drumPad":"DrumPads_drumPad__1Y8Qq"};